module.exports = __webpack_public_path__ + "static/media/Exhibition-3@2x.0dde7792.png";